import React from "react";

const OpportunityKanban = ({ stages, opportunities, onMove, movingId }) => {
  return (
    <div className="crm-kanban-board">
      {stages.map((stage) => {
        const stageRows = opportunities.filter(
          (row) => row.stage_id === stage.id
        );

        return (
          <div key={stage.id} className="crm-kanban-column">
            <div className="crm-kanban-column-header">
              <h4 className="crm-kanban-column-title">{stage.name}</h4>
              <span className="crm-kanban-column-count">
                {stageRows.length}
              </span>
            </div>

            {stageRows.length === 0 ? (
              <div className="crm-kanban-empty">No deals here yet</div>
            ) : null}

            {stageRows.map((row) => (
              <div key={row.id} className="crm-kanban-card">
                <div className="crm-kanban-card-top">
                  <div className="crm-kanban-card-title">{row.name}</div>

                  <span
                    className={`crm-badge status-${String(
                      row.status || "open"
                    ).replace(/\s+/g, "_")}`}
                  >
                    {row.status || "open"}
                  </span>
                </div>

                <div className="crm-kanban-card-meta">
                  {row.crm_accounts?.name || "No account"}
                </div>

                <div className="crm-kanban-card-stats">
                  <div className="crm-kanban-stat">
                    <span>Amount</span>
                    <strong>₦{Number(row.amount || 0).toLocaleString()}</strong>
                  </div>

                  <div className="crm-kanban-stat">
                    <span>Probability</span>
                    <strong>{Number(row.probability || 0)}%</strong>
                  </div>
                </div>

                <div className="crm-inline-actions">
                  <a
                    className="crm-small-btn"
                    href={`/crm/opportunities/${row.id}`}
                  >
                    Open
                  </a>

                  <a
                    className="crm-small-btn alt"
                    href={`/crm/quotes?opportunityId=${row.id}`}
                  >
                    New Quote
                  </a>
                </div>

                <select
                  className="crm-select crm-kanban-select"
                  value={row.stage_id || ""}
                  onChange={(event) => onMove(row.id, event.target.value)}
                  disabled={movingId === row.id}
                >
                  {stages.map((stageOption) => (
                    <option key={stageOption.id} value={stageOption.id}>
                      {stageOption.name}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default OpportunityKanban;
